class MiniCart extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.header = document.querySelector("sticky-header"), this.drawer = document.querySelector("cart-drawer"), new IntersectionObserver(this.handleIntersection.bind(this)).observe(this)
    }
    handleIntersection(e, t) {
        e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url).then((e => e.text())).then((e => {
            document.getElementById("mini-cart").innerHTML = this.getSectionInnerHTML(e, ".shopify-section"), document.dispatchEvent(new CustomEvent("cartdrawer:opened"))

            new Swiper('.empty-cart-recommendations-slider', {
                loop: false,
                navigation: {
                    nextEl: `.swiper-button-next`,
                    prevEl: `.swiper-button-prev`,
                },
                slidesPerView: 1.5,
                paginationClickable: true,
                spaceBetween: 15,
                breakpoints: {
                    749: {
                        slidesPerView: 2.7
                    },
                    450: {
                        slidesPerView: 3
                    },
                },
            });
        })).catch((e => {
            console.error(e)
        })))
    }
    open() {
        this.drawer.querySelector("details").hasAttribute("open") || this.drawer.openMenuDrawer()
    }
    renderContents(e) {
        this.productId = e.id, this.getSectionsToRender().forEach((t => {
            document.getElementById(t.id) && (document.getElementById(t.id).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector))
        })), this.open()
        
    }
    getSectionsToRender() {
        return [{
            id: "mini-cart",
            section: "mini-cart",
            selector: ".shopify-section"
        }, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }, {
            id: "mobile-cart-icon-bubble",
            section: "mobile-cart-icon-bubble",
            selector: ".shopify-section"
        }]
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
    }
}
customElements.define("mini-cart", MiniCart);